import React, { useState, useEffect } from "react";
import "../../styles/glass.css";
import "../../styles/globals.css";
import "../../styles/layout.css";
import "../styles/platform.css";
import "../styles/LeftSidebar.css";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import HeaderPlatform from "../components/HeaderPlatform";
import FooterPlatform from "../components/FooterPlatform";
import LeftSidebar from "../components/LeftSidebar";
import GlassCard from "../../components/GlassCard";
import { costumDateText } from "../data/platformText";
import { getPlanByDate } from "../api/planApi";
import LoadingPage from "./LoadingPage";
import ErrorPage from "./ErrorPage";

export const CostumDatePage = () => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const t = costumDateText[lang];
  const date = searchParams.get("date");

  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadPlan() {
      try {
        setLoading(true);
        setError("");
        const data = await getPlanByDate(date);
        setPlan(data);
      } catch (err) {
        const message = err.message || "Failed to load plan";


        if (message === "No active plan found for current user") {
          setPlan(null);
          setError("");
        } else {
          setError(message);
        }
      } finally {
        setLoading(false);
      }
    }

    if (date) {
      loadPlan();
    } else {
      setLoading(false);
      setError("Missing date query parameter");
    }
  }, [date]);

  const sessions = plan?.sessions ?? [];
  const activeSessions = sessions.filter((session) => !session.completed);
  const completedSessions = sessions.filter((session) => session.completed);

  const handleGoToSessionDetail = (session) => {
    navigate({
      pathname: `/${lang}/platform/sessions/${session.id}`
    });
  };

  if (loading) {
    return <LoadingPage/>
  }

  if (error) {
    return <ErrorPage err={error}/>;
  }

  return (
    <div className="revimo-layout">
      <HeaderPlatform />

      <main className="revimo-main">
        <LeftSidebar />

        <div className="revimo-page-content">
          <GlassCard
            style={{
              padding: "20px",
              borderRadius: "24px",
              display: "flex",
              flexDirection: "column",
              gap: "18px",
              minHeight: "280px",
              marginLeft: "50px",
              marginTop: "25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <span
                style={{
                  fontSize: "0.8rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  opacity: 0.7,
                }}
              >
                {t.s} {" "} {date}.
              </span>

              <h3
                style={{
                  margin: 0,
                  fontSize: "1.3rem",
                  fontWeight: 700,
                  color: "#0b1720",
                }}
              >
                {activeSessions.length > 0 ? `${t.todayPlan1}${date}` : t.todayPlan2}
              </h3>

              <p
                style={{
                  margin: 0,
                  fontSize: "0.95rem",
                  color: "#4c6a7a",
                }}
              >
                {activeSessions.length > 0 ? t.activeSess1 : t.activeSess2}
              </p>
            </div>

            {sessions.length > 0 && (
              <GlassCard
                className="exercise-header"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px",
                  height: "40px",
                  background: "#eef5ff89",
                  marginTop: "25px",
                }}
              >
                <div style={{ width: "250px", fontSize: "0.95rem", color: "#0b1720" }}>
                  {t.hName}
                </div>
                <div style={{ fontSize: "0.95rem", color: "#0b1720" }}>
                  {t.hDifficulty}
                </div>
                <div style={{ fontSize: "0.95rem", color: "#0b1720" }}>
                  {t.hNofSets}
                </div>
                <div style={{ fontSize: "0.95rem", color: "#0b1720" }}>
                  {t.hTime}
                </div>
              </GlassCard>
            )}

            {activeSessions.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {activeSessions.map((session) => (
                  <button
                    key={session.id}
                    type="button"
                    onClick={() => handleGoToSessionDetail(session)}
                    style={{
                      border: "none",
                      background: "rgba(255,255,255,0.28)",
                      borderRadius: "16px",
                      padding: "14px 16px",
                      cursor: "pointer",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        width: "250px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "1rem",
                          fontWeight: 600,
                          color: "#0b1720",
                        }}
                      >
                        {session.name}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "0.92rem",
                          color: "#0b1720",
                        }}
                      >
                        {session.hardness_score ?? "-"}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "0.92rem",
                          color: "#0b1720",
                        }}
                      >
                        -
                      </span>
                    </div>

                    <span
                      style={{
                        fontSize: "0.92rem",
                        color: "#0b1720",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {session.estimated_time ?? "-"}
                    </span>
                  </button>
                ))}
              </div>
            )}

            {completedSessions.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "4px",
                }}
              >
                <div
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    color: "#0b1720",
                  }}
                >
                  Completed:
                </div>

                {completedSessions.map((session) => (
                  <div
                    key={session.id}
                    style={{
                      borderRadius: "16px",
                      padding: "12px 16px",
                      background: "rgba(255,255,255,0.05)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      opacity: 0.75,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "0.98rem",
                        textDecoration: "line-through",
                        color: "#0b1720",
                        width: "250px",
                      }}
                    >
                      {session.name}
                    </span>

                    <span
                      style={{
                        fontSize: "0.9rem",
                        whiteSpace: "nowrap",
                        color: "#0b1720",
                      }}
                    >
                      {session.hardness_score ?? "-"}
                    </span>

                    <span
                      style={{
                        fontSize: "0.9rem",
                        whiteSpace: "nowrap",
                        color: "#0b1720",
                      }}
                    >
                      -
                    </span>

                    <span
                      style={{
                        fontSize: "0.9rem",
                        whiteSpace: "nowrap",
                        color: "#0b1720",
                      }}
                    >
                      {session.estimated_time ?? "-"}
                    </span>
                  </div>
                ))}
              </div>
            )}

            {sessions.length === 0 && (
              <div
                style={{
                  fontSize: "0.98rem",
                  color: "#4c6a7a",
                  marginTop: "8px",
                }}
              >
               {t.noScheduled}
              </div>
            )}
          </GlassCard>
        </div>
      </main>

      <footer className="revimo-footer">
        <FooterPlatform />
      </footer>
    </div>
  );
};

export default CostumDatePage;